<h1 id="impot-personnel">Impôt personnel</h1>


<app-rrsp-personal-tax-spouse-form [form]="form"
  [incomeTaxPersonalSpouseForm]="mainPersonForm"
  [isSpouse]="false"
></app-rrsp-personal-tax-spouse-form>


<div class="row mt-5">
  <div class="col-12">
    @if (this.incomeTaxPersonalForm.value.isMarried === true) {
      <app-rrsp-personal-tax-spouse-form
        [form]="form" [incomeTaxPersonalSpouseForm]="spouseForm"
      [isSpouse]="true"></app-rrsp-personal-tax-spouse-form>
    }

    <app-rrsp-personal-tax-children-form [children]="childrenForm"
    [form]="form"></app-rrsp-personal-tax-children-form>
  </div>
</div> <!-- / .row -->



